module.exports = __webpack_public_path__ + "img/device-mobile-ru.4d613b30.png";